// An object because we were trying to load from global settings.
const defaultUrls = {
  "loading-bar": "/loading"
};

const defaultSettings = {
  language: "en",
  workspace: {
    temperatureCurves: [],
    colourCurves: {},
    pollingFrequency: 0
  }
};

export { defaultUrls, defaultSettings };
